'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getMuted = function getMuted(val) {
  if (val === undefined) return '';
  switch (val) {
    case 1:
    default:
      return (0, _glamor.css)({ opacity: 0.85 });
    case 2:
      return (0, _glamor.css)({ opacity: 0.7 });
  }
};

var getColor = function getColor(_ref) {
  var white = _ref.white;

  if (white) return (0, _glamor.css)({ color: _theme2.default.colors.white });
  return '';
};

var parseProps = function parseProps(_ref2) {
  var className = _ref2.className,
      muted = _ref2.muted,
      white = _ref2.white,
      props = _objectWithoutProperties(_ref2, ['className', 'muted', 'white']);

  return _extends({
    className: (0, _classnames2.default)('' + getColor({ white: white }), '' + getMuted(muted), className)
  }, props);
};

var Text = function Text(props) {
  return _react2.default.createElement(_Box2.default, parseProps(props));
};

Text.propTypes = {
  white: _propTypes2.default.bool
};

Text.defaultProps = {
  is: 'p'
};

Text.displayName = 'Text';

exports.default = Text;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Text.js
// module id = 138
// module chunks = 0